import React from 'react';
import { useParams } from 'react-router-dom';
import { PushComponent, UiComponent } from 'components';
import { PushQuery } from 'queries';

function Detail() {
  const { id } = useParams<{ id: string }>();
  const { data: push } = PushQuery.useGet(id ?? '');

  if (!push) return null;

  return (
    <>
      <UiComponent.PageTitle>푸시 상세</UiComponent.PageTitle>
      <PushComponent.Detail push={push} />
    </>
  );
}

export default Detail;
